import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { SUPPLIER_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import SupplierForm from './SupplierForm';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import {
  clearSupplier,
  getSupplier,
  putSupplier,
} from '../../../../actions/food/Supplier';
import {
  BILLING_TYPE,
  CREDIT_TIME,
  FOOD_PUBLIC_TYPE,
  SUPPLIER_TYPE,
} from '../../../../config/constants';

const EditSupplier = ({
  breadcrumbs,
  dispatchPutSupplier,
  dispatchGetSupplier,
  dispatchClearSupplier,
  match: {
    params: { id: supplierId },
  },
  loading,
  supplier,
}) => {
  useLayoutEffect(() => {
    dispatchGetSupplier({ supplierId });

    return () => dispatchClearSupplier();
  }, []);

  const onSubmit = (formValues) => {
    const newFormValues = {
      ...formValues,
      businessId: formValues.businessId.value,
      billingType: formValues.billingType.value,
      type: formValues.type.value,
      creditTime: formValues.creditTime.value,
      locationId: formValues.locationId.value,
      userId: formValues.userId.value,
      active: true,
      supplierFoodTypeList: formValues.supplierFoodTypeList
        ? formValues.supplierFoodTypeList.map((item) => ({
            foodId: item.food.value,
            cost: item.cost,
            publicType: item.publicType.value,
          }))
        : [],
    };

    dispatchPutSupplier(supplierId, newFormValues);
  };

  const generateInitialValues = (supplierJson) => ({
    businessId: supplierJson.business
      ? {
          value: supplierJson.business.id,
          label: `${supplierJson.business.businessTaxId} - ${supplierJson.business.name}`,
        }
      : null,
    locationId: supplierJson.location
      ? {
          value: supplierJson.location.id,
          label: supplierJson.location.name,
        }
      : null,
    userId: supplierJson.user
      ? {
          value: supplierJson.user.id,
          label: `${supplierJson.user.fullName}`,
        }
      : null,
    billingType: BILLING_TYPE[supplierJson.billingType],
    type: SUPPLIER_TYPE[supplierJson.type],
    creditTime: CREDIT_TIME[supplierJson.creditTime],
    bankAccountNumber: supplierJson.bankAccountNumber,
    phoneNumber: supplierJson.phoneNumber,
    active: supplierJson.active,
    supplierFoodTypeList: supplierJson.supplierFoodTypeList
      ? supplierJson.supplierFoodTypeList.map((item) => ({
          id: item.id,
          supplierId: item.supplierId,
          food: item.food
            ? {
                value: item.food.id,
                label: item.food.name,
              }
            : item.foodId,
          cost: item.cost,
          publicType: FOOD_PUBLIC_TYPE[item.publicType],
        }))
      : [],
  });

  let content;

  if (loading) content = <Loader />;
  else if (supplier.isEmpty())
    content = <NoDataResource returnPage={SUPPLIER_PATH} />;
  else
    content = (
      <SupplierForm
        edit
        onSubmit={onSubmit}
        initialValues={generateInitialValues(supplier.toJS())}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Proveedor"
      subtitle="Editar proveedor"
      content={content}
    />
  );
};

EditSupplier.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPutSupplier: PropTypes.func.isRequired,
  dispatchClearSupplier: PropTypes.func.isRequired,
  dispatchGetSupplier: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  supplier: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditSupplier.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchPutSupplier: putSupplier,
  dispatchGetSupplier: getSupplier,
  dispatchClearSupplier: clearSupplier,
};

const mapStateToProps = (
  { FoodUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...FoodUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Proveedores',
      href: SUPPLIER_PATH,
    },
    {
      text: 'Ver',
      href: `${SUPPLIER_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  supplier: FoodUnit.Supplier.getIn(['current', 'content']),
  loading: !FoodUnit.Supplier.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSupplier);
